import { Component, Input, Output } from "@angular/core";
import { Subject } from "rxjs";
import { PubNubService } from "@builder-services/core/pubnub.service";
import { ModalService } from "../../modal/modal.service";

@Component({
    selector: "app-eviction-modal",
    templateUrl: "./eviction-modal.component.html",
    styleUrls: ["./eviction-modal.component.scss"],
})
export class EvictionModalComponent {
    @Input() data: any;
    @Output() output: Subject<boolean> = new Subject<boolean>();

    constructor(
        private modalService: ModalService,
        private pubNubService: PubNubService,
    ) {}

    ngOnInit(): void {
        const myUserId = this.pubNubService.getUserId();

        if (this.data?.type === "eviction") {
            this.pubNubService.listenPresence((presence) => {
                if (
                    (presence.action === "leave" || presence.action === "timeout") &&
                    decodeURIComponent(presence.uuid) !== decodeURIComponent(myUserId)
                ) {
                    this.modalService.close("eviction-modal");
                }
            });
        }
    }

    private closeEvictionModal(): void {
        this.modalService.close("eviction-modal");
    }

    redirectToCampaigns(): void {
        window.location.href = "/campaigns";
    }

    onGoBackClick(): void {
        this.closeEvictionModal();
        this.redirectToCampaigns();
    }

    onEvictClick(): void {
        this.pubNubService.sendMessage(this.data.campaignId, {
            type: "evict",
            fromUUID: this.pubNubService.getUserId(),
            targetUUID: this.data.targetUserId,
        });
        this.pubNubService.removeAllPresenceListeners();
        this.closeEvictionModal();
    }

    onTakeoverNoticeClick(): void {
        this.closeEvictionModal();
        this.redirectToCampaigns();
    }

    onTakeoverConfirmedClick(): void {
        this.closeEvictionModal();
    }

}
